import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import CardHeader from '@/components/Includes/CardHeader/CardHeader.vue';
import Loader from '@/components/Includes/Loader/Loader.vue';
import Pagination from '@/components/Includes/Pagination/Pagination.vue';
import SelectionColumnsInTable from '@/components/Includes/SelectionColumnsInTable/SelectionColumnsInTable.vue';
import TableEmpty from '@/components/Includes/Table/TableFooter/TableEmpty/TableEmpty.vue';
import IPayloadQuery from '@/interfaces/IPayloadQuery';
import IReceipt from '@/interfaces/IReceipt';
import ITableCol from '@/interfaces/ITableCol';
import IMultiSelectItem from '@/interfaces/selects/IMultiSelectItem';
import ISelectItemDefault from '@/interfaces/selects/ISelectItemDefault';
import dateToStandart from '@/libs/date/dateToStandart';
import defaultDate from '@/libs/date/defaultDate';

const today = new Date();
@Component({
    name: 'ReceiptsList',
    components: {
        'vue-picker': VueCtkDateTimePicker,
        CardHeader,
        Pagination,
        SelectionColumnsInTable,
        TableEmpty,
        Loader
    }
})
export default class ReceiptsList extends Vue {
    @Action private receiptsList!: (payload: IPayloadQuery) => Promise<void>;
    @Getter private getReceiptsList!: () => IReceipt[];

    // Begin Config Date Picker
    private date: { start: string, end: string } = {
        start: '',
        end: ''
    };

    private config: any = {
        format: 'YYYY-MM-DD',
        formatted: 'll',
        range: true,
        overlay: true,
        dark: true
    };
    // End Config Date Picker

    private loading: boolean = true;
    private receipts: IReceipt[] = [];
    private totalReceipts: number | void | null = null;

    private currentPage: number = 1;

    private selectedTableColumns: IMultiSelectItem[] = [];

    private selectedLimit: string = '100';

    private limits: ISelectItemDefault[] = [
        { value: '100', text: '100' },
        { value: '250', text: '250' },
        { value: '500', text: '500' }
    ]

    private get dateStart() {
        return this.date.start;
    }

    private get dateEnd() {
        return this.date.end === null ? this.dateStart : this.date.end;
    }

    private get selectedDateInterval() {
        return `${this.dateStart} / ${this.dateEnd}`;
    }

    private get notEmpty() {
        return this.getReceiptsList().length !== 0;
    }

    private get fields() {
        if (this.tableColumns) {
            const columnsIds = this.selectedTableColumns.map((el: IMultiSelectItem) => el.value);
            return this.tableColumns.filter((el: any) => columnsIds.includes(el.key));
        } else {
            return this.tableColumns;
        }
    }

    public detailReceipt (receipt: any) {
        this.$router.push({
            name: 'receipt_detail',
            params: { id: receipt.id, receiptData: receipt }
        });
    }

    private get tableColumns(): ITableCol[] | undefined {
        if (this.receipts) {
            if (this.receipts.length > 0) {
                const items = Object.keys(this.receipts[0]).map(item => {
                    return {
                        key: item
                    }
                })
                return items;
            }
        }
    };

    private checkDateField(field: string) {
        const dateField = {
            field,
            class: 'table-receipts__date'
        }
        switch (field) {
            case 'purchaseDate':
                return dateField;
            case 'expiresDate':
                return dateField;
            case 'cancellationDate':
                return dateField;
            case 'originalPurchaseDate':
                return dateField;
            case 'subscriptionCreatedAt':
                return dateField;
            default:
                return field;
        }
    }

    private transformDataByDate() {
        this.receipts.forEach((receipt: IReceipt) => {
            if (receipt.purchaseDate) {
                receipt.purchaseDate = dateToStandart(receipt.purchaseDate)
            }
            if (receipt.expiresDate) {
                receipt.expiresDate = dateToStandart(receipt.expiresDate)
            }
            if (receipt.cancellationDate) {
                receipt.cancellationDate = dateToStandart(receipt.cancellationDate)
            }
            if (receipt.originalPurchaseDate) {
                receipt.originalPurchaseDate = dateToStandart(receipt.originalPurchaseDate)
            }
            if (receipt.subscriptionCreatedAt) {
                receipt.subscriptionCreatedAt = dateToStandart(receipt.subscriptionCreatedAt)
            }
        })
        return this.receipts;
    }

    private getDefaultDate() {
        const initDate = defaultDate(7, false);
        if(initDate){
            this.date.start = initDate.start;
            this.date.end = initDate.end;
        }
    }

    private changedTableColumns(columnsList: IMultiSelectItem[]) {
        this.selectedTableColumns = columnsList
    }

    private get payloadQuery(): IPayloadQuery {
        const hourStart = '00:00:00';
        const hourEnd = '23:59:59';
        return {
            query: `?pagination=true&page=${this.currentPage}&limit=${this.selectedLimit}&subscriptionCreatedAt[after]=${this.dateStart}T${hourStart}&subscriptionCreatedAt[before]=${this.dateEnd}T${hourEnd}`
        }
    }

    @Watch('selectedLimit')
    @Watch('currentPage')
    private async loadReceipts() {
        this.loading = true;
        this.totalReceipts = await this.receiptsList(this.payloadQuery);
        this.receipts = this.getReceiptsList();
        this.transformDataByDate();
        this.loading = false;
    }

    private async mounted() {
        try {
            this.getDefaultDate();
            this.loadReceipts();
        } catch (error) {
            return Promise.reject('Error loading data')
        }
    }
}
